import React, { useState } from "react";
import WolfMark from "@/components/WolfMark";
import { api, formatApiError } from "@/lib/wolfApi";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    try {
      const res = await api.post("/newsletter", { email });
      setStatus({ ok: true, msg: res.data.message || "Welcome to The Pack." });
      setEmail("");
    } catch (err) {
      setStatus({ ok: false, msg: formatApiError(err.response?.data?.detail) || err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="relative bg-[#080808] border-t border-white/10 mt-32" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 sm:px-10 lg:px-16 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-5">— Mailing list</p>
          <h3 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.95]">
            Join<br/>The Pack.
          </h3>
          <p className="font-editorial italic text-lg text-white/55 mt-6 max-w-md">
            Early access to releases, unreleased writings from the Fire Pages, and the occasional letter from the dark.
          </p>

          <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl" data-testid="newsletter-form">
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent border border-white/15 px-5 py-4 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition-colors font-body"
            />
            <button
              type="submit"
              disabled={submitting}
              data-testid="newsletter-submit-btn"
              className="font-display tracking-[0.4em] text-sm btn-gold-fill text-black border border-[#D4AF37] px-8 py-4 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {submitting ? "Sending…" : "Run With Us"}
            </button>
          </form>
          {status && (
            <p
              data-testid="newsletter-status"
              className={`mt-4 text-sm ${status.ok ? "text-[#D4AF37]" : "text-red-300"}`}
            >
              {status.msg}
            </p>
          )}
        </div>

        <div className="lg:col-span-5 lg:pl-10 flex flex-col justify-between gap-10">
          <div className="flex items-start gap-4">
            <WolfMark className="w-12 h-12" />
            <div>
              <p className="font-display text-3xl text-white tracking-extreme">WOLF</p>
              <p className="font-editorial italic text-white/45 mt-1">Forged in the dark. Still standing.</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 text-[11px] uppercase tracking-[0.28em] text-white/55">
            <a href="https://open.spotify.com/artist/3b0xMgt8u93GykFDiAXslc?si=zanefZxySXKyZg1kTiTFdQ" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-spotify">Spotify</a>
            <a href="https://music.apple.com/au/artist/wolf/1470858095" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-apple">Apple Music</a>
            <a href="https://youtube.com/@WOLFMUSICAU" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-youtube">YouTube</a>
            <a href="https://instagram.com/wolfmusicau" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-instagram">Instagram</a>
            <a href="https://tiktok.com/@wolfmusicau" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-tiktok">TikTok</a>
            <a href="mailto:hello@wolf.com" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-contact">Contact</a>
          </div>

          <p className="text-[10px] uppercase tracking-[0.3em] text-white/30">
            © {new Date().getFullYear()} WOLF · Mark Leslie
          </p>
        </div>
      </div>
    </footer>
  );
}
